import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AbstractButtonComponent } from '../abstract-button.component';

/**
 * Similar to swatch but presents checkbox icon instead
 */

export type TIconButton = 'default' | 'filled';
@Component({
    selector: 'button[iconButton], a[iconButton]',
    templateUrl: './icon-button.html',
    styleUrls: ['./icon-button.scss'],
    standalone: true,
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent extends AbstractButtonComponent {
    @Input()
    iconButton: TIconButton | undefined | '' = 'default';

    @HostBinding('class._animated-text')
    @Input()
    textAnimated?: string;

    protected variantInputName = 'iconButton';
}
